<div class="modal notification-modal sysinfo-modal" tabindex="-1" role="dialog" *ngIf="activeModal">
    <div class="modal-dialog" role="document">

        <div id="sysinfo-content" class="modal-content">
            <button type="button" class="close btn-black-close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"></button>

            <div class="container container-sysinfo px-2 py-2">
                <div class="modal-header py-0">
                    <div class="col-sm-2 sysinfo-image-block"></div>
                    <div class="modal-title">System Information</div>
                </div>
                <div class="pl-3 ml-3">
                <div class="row">
                    <span class="card-title">Version Number</span>
                    <span class="col-md-7 card-text"><i>{{version}}</i></span>
                </div>
                <div class="row">
                    <span class="card-title">OS</span>
                    <span class="col-md-7 card-text">{{operatingSystem}}</span>
                </div>
                <!-- TODO: This didn't appear to be available on my home network on RAv1, need to check in the office - RS -->
                <!--<div class="row">-->
                    <!--<span class="col-md-5 card-title text-md-right">Memory</span>-->
                    <!--<span class="col-md-7 card-text"><i>?Coming Soon?</i></span>-->
                <!--</div>-->
                <div class="row">
                    <span class="card-title">User Name</span>
                    <span class="col-md-7 card-text">{{learnerName}}</span>
                </div>
                <div class="row">
                    <span class="card-title">Server</span>
                    <span class="col-md-7 card-text">{{slcLocation}}</span>
                </div>
                <div class="row">
                    <span class="card-title">Browser</span>
                    <span class="col-md-7 card-text">{{browser}}</span>
                </div>
                <div class="row">
                    <span class="card-title">Screen Resolution</span>
                    <span class="col-md-7 card-text">{{screenResolution}}</span>
                </div>
                <div class="row" *ngIf="!!audioContext">
                    <span class="card-title">Sound</span>
                    <span class="col-md-7 card-text">
                        State: {{audioContext.destination.context.state.toUpperCase()}}<br />
                        Input Channels: {{audioContext.destination.numberOfInputs}}<br />
                        Max Channel Count: {{audioContext.destination.channelCount}}<br />
                    </span>
                </div>
                <div class="row" *ngIf="currentAudioDevice !== ''">
                    <span class="card-title">Current Audio Device</span>
                    <span class="col-md-7 card-text">{{currentAudioDevice}}</span>
                </div>

                <div class="row" *ngFor="let device of audioDevices; let idx = index">
                    <span class="card-title">Audio Device {{idx + 1}}</span>
                    <span class="col-md-7 card-text">{{device.name}}</span>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade in" *ngIf="activeModal"></div>
